'use client'

import { FooterLinkSection } from './FooterLinkSection'
import type { GetCommonsFooterResponseData } from '@/queries/footer'
import type { ReactNode } from 'react'
import type { FooterLinkSectionProps } from './FooterLinkSection'
import type { FooterType } from '@/providers/AppLayoutProvider'
import { filterByScope } from '@/helpers/scope'

type Props = {
  data: GetCommonsFooterResponseData
  AppBanners?: ReactNode
  type?: FooterType
}

export const FooterLinksContainer = ({
  data,
  AppBanners,
  type = 'general',
}: Props) => {
  const getItems = (
    items: GetCommonsFooterResponseData['footer']['help']['items'],
  ) => {
    return filterByScope(items, type).map((item) => ({
      label: item.label ?? '',
      href: item.url ?? '',
      icon: <img src={item.image_url} aria-hidden="true" />,
    }))
  }

  const mainFooterLinks: Array<FooterLinkSectionProps> = [
    {
      title: data.footer.help.label,
      icon: <img src={data.footer.help.image_url} aria-hidden="true" />,
      items: getItems(data.footer.help.items),
      useRouterLink: true,
    },
    {
      title: data.footer.learn_more.label,
      icon: <img src={data.footer.learn_more.image_url} aria-hidden="true" />,
      items: getItems(data.footer.learn_more.items),
      useRouterLink: true,
    },
    {
      title: data.footer.delivery_and_freight.label,
      icon: (
        <img
          src={data.footer.delivery_and_freight.image_url}
          aria-hidden="true"
        />
      ),
      items: getItems(data.footer.delivery_and_freight.items),
    },
  ]

  return (
    <FooterLinkSection.Container
      defaultValue={mainFooterLinks[0]?.title ? [mainFooterLinks[0].title] : []}
    >
      {mainFooterLinks.map((link, index) => (
        <li key={link.title} className="contents w-full lg:block">
          <FooterLinkSection {...link} />

          {index === 2 && AppBanners}
        </li>
      ))}
    </FooterLinkSection.Container>
  )
}
